import "@css/style.css";

// Import VideoUtils
import { VideoUtils } from './utils/video.js';

// Make VideoUtils available globally
window.VideoUtils = VideoUtils;

/* Rotate Arrow on Career Block when clicked */
$(".career-button").click(function() {
	$(this).find('.arrow-icon').toggleClass('rotate');
});

// Add header scroll effect
document.addEventListener('DOMContentLoaded', function() {
	const header = document.getElementById('header');
	let lastScroll = 0;

	window.addEventListener('scroll', () => {
		const currentScroll = window.pageYOffset;

		// Add/remove class based on scroll direction
		if (currentScroll > lastScroll && currentScroll > 100) {
			// Scrolling down & past the header
			header.classList.add('is-scrolling');
		} else {
			// Scrolling up
			header.classList.remove('is-scrolling');
		}

		lastScroll = currentScroll;
	});
});


import 'lazysizes';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]");

// Initialize any existing videos on page load
document.addEventListener('DOMContentLoaded', function() {
	// Log to verify script is running
	console.log('Initializing videos...');
});